import { render, staticRenderFns } from "./TeachersDay2021.vue?vue&type=template&id=771ae6ce&scoped=true&"
import script from "./TeachersDay2021.vue?vue&type=script&lang=js&"
export * from "./TeachersDay2021.vue?vue&type=script&lang=js&"
import style0 from "./TeachersDay2021.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TeachersDay2021.vue?vue&type=style&index=1&id=771ae6ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ae6ce",
  null
  
)

export default component.exports